<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-primary" style="width:100%">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{ $t("apartmentBooking.title") }}</b>
            </div>
            <div class="col-md-12 col-ld-12 col-sd-12">
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar">
                        <label>
                          <span style="margin-left:5px;display:inline-block;"
                            >{{ $t("service_history.date_from") }}:</span
                          >
                        </label>
                      </i>
                    </div>
                    <date-picker
                      :config="options"
                      :value="bookingDate.checkin_datetime"
                      v-model="bookingDate.checkin_datetime"
                    ></date-picker>
                  </div>
                </div>
              </div>

              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar">
                        <label>
                          <span style="margin-left:5px;display:inline-block;"
                            >{{ $t("service_history.date_to") }}:</span
                          >
                        </label>
                      </i>
                    </div>
                    <date-picker
                      :config="options"
                      :value="bookingDate.checkout_datetime"
                      v-model="bookingDate.checkout_datetime"
                    ></date-picker>
                  </div>
                </div>
              </div>

              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="bookingDate.searchText"
                  />
                </div>
              </div>

              <!-- Search booking available list -->
              <div class="col-sm-2 col-md-2 col-lg-2">
                <button
                  type="button"
                  class="btn btn-labeled btn-primary pull-left"
                  @click="onSearchApartmentBooking"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("common.search") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!--  -->
        <div class="box-footer clearfix" style="display:contents;"></div>
        <!--  -->
        <div class="nav-tabs-custom">
          <ul class="nav nav-tabs">
            <li class="active" @click="onClickTabs(1)">
              <a :href="'#tab_1'" data-toggle="tab" aria-expanded="true"
                >{{
                  $t(
                    "apartmentBooking.apartmentBookingTabs.apartmentBookingList"
                  )
                }}
              </a>
            </li>
            <li @click="onClickTabs(2)">
              <a :href="'#tab_2'" data-toggle="tab" aria-expanded="true"
                >{{
                  $t(
                    "apartmentBooking.apartmentBookingTabs.apartmentBookingTimeLine"
                  )
                }}
              </a>
            </li>
          </ul>
          <div class="tab-content" style="padding: 0">
            <div class="tab-pane active" id="tab_1">
              <div class="box-body">
                <div class="col-md-12">
                  <div class="row">
                    <div class="form-group">
                      <button
                        type="button"
                        class="btn btn-labeled btn-primary pull-right"
                        @click="onAddNewBooking"
                      >
                        <span class="btn-label">
                          <i class="glyphicon glyphicon-plus"></i>
                        </span>
                        {{ $t("common.addnew") }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="" style="display: flex; padding: 0 15px">
                  <span
                    v-for="(item, index) in bookingStatusList"
                    :key="item + index"
                    :class="
                      `${
                        index !== bookingStatusList.length - 1
                          ? 'customer-type-class border-right'
                          : 'customer-type-class'
                      }`
                    "
                    @click="onChangeBookingStatus(item.value)"
                  >
                    <span
                      :class="
                        item.value === bookingStatusSelect
                          ? 'customer-type-select'
                          : ''
                      "
                      style="white-space: nowrap;"
                    >
                      {{ $t(item.text) }} ({{ item.total }})
                    </span>
                  </span>
                </div>
                <div class="col-md-12" style="margin-top: 15px">
                  <b-table
                    outlined
                    :items="apartmentBookingItems"
                    :fields="apartmentBookingFields"
                    :tbody-tr-class="rowClass"
                    responsive
                  >
                    <template #head()="scope">
                      <div class="">{{ $t(scope.label) }}</div>
                    </template>
                    <template #cell(actions)="row">
                      <button
                        class="btn btn-primary btn-sm"
                        style="margin-right: 6px;"
                        @click="onOpenBookingDetail(row.item)"
                      >
                        <i class="glyphicon glyphicon-edit"></i>
                      </button>
                      <button
                        v-if="
                          row.item.status !== ApartmentBookingStatus.CANCEL &&
                            row.item.isCancelBooking
                        "
                        class="btn btn-warning btn-sm"
                        @click="onShowModalReasonCancelBooking(row.item)"
                      >
                        <i class="glyphicon glyphicon-remove"></i>
                      </button>
                    </template>
                  </b-table>
                  <div class="box-footer clearfix" style="display:contents;">
                    <custom-paginator
                      :totalItem="paginateData.totalItem"
                      :currentPage="paginateData.currentPage"
                      :pageSize="paginateData.pageSize"
                      :totalPage="paginateData.totalPage"
                      @onpaginate="onCustomPagination"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane" id="tab_2">
              <div>
                <!-- <apartment-booking-time-line /> -->
              </div>
            </div>
          </div>
        </div>
        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar"
        ></lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
        <!--component-->
      </row>
    </div>
    <!-- input reason cancel -->
    <div
      class="modal fade"
      :ref="`modal-reason-cancel-booking`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="onCloseReasonCancelBooking"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("apartmentBooking.reasonCancelBooking.title") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="">{{
                        $t("apartmentBooking.reasonCancelBooking.title")
                      }}</label>
                      <textarea
                        type="text"
                        class="form-control"
                        cols="30"
                        rows="6"
                        v-model="cancelBookingData.reasonCancel"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onCloseReasonCancelBooking"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onShowConfirmCancelBooking"
            >
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
      </div>
      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
    </div>
    <!--  -->
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirm"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LTEModal from "@/components/LTEModal.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
import utils from "@/lib/utils";
import datePicker from "vue-bootstrap-datetimepicker";
import CustomPaginator from "@/components/CustomPaginator.vue";
// import ApartmentBookingTimeLine from "./ApartmentBookingTimeLine";
import Enum from "../../../enum/enum";

export default {
  components: {
    "lte-modal": LTEModal,
    "lte-core-alert": LTECoreAlert,
    loading: Loading,
    "date-picker": datePicker,
    CustomPaginator
    // ApartmentBookingTimeLine
  },
  name: "LeaseBackAvailableApartmentList",
  data() {
    return {
      bookingStatusSelect: null,
      bookingStatusList: [
        { value: null, text: "project.all", total: 0 },
        {
          value: 1,
          text: "apartmentBooking.statusList.waitingCheckIn",
          total: 0
        },
        { value: 3, text: "apartmentBooking.statusList.checkedIn", total: 0 },
        { value: 4, text: "apartmentBooking.statusList.checkOut", total: 0 },
        { value: 2, text: "apartmentBooking.statusList.cancel", total: 0 }
      ],
      apartmentBookingItems: [],
      apartmentBookingFields: [
        {
          key: "nonumber",
          label: "common.nonumber"
          // _rowVariant: 'danger'
        },
        {
          key: "bookingCode",
          label: "apartmentBooking.bookingCode"
        },
        {
          key: "customerName",
          label: "apartmentBooking.customerName"
        },
        {
          key: "customerPhone",
          label: "apartmentBooking.phone"
        },
        // {
        //   key: "customerName",
        //   label: "apartmentBooking"
        // },
        // {
        //   key: "apartmentName",
        //   label: "apartmentBooking.apartmentName"
        // },
        {
          key: "checkInDate",
          label: "apartmentBooking.checkInDate"
        },
        {
          key: "checkOutDate",
          label: "apartmentBooking.checkOutDate"
        },
        { key: "actions", label: "common.action" }
      ],
      paginateData: {
        totalItem: 1,
        currentPage: 1,
        pageSize: 1,
        totalPage: 1
      },
      bookingDate: {
        checkin_datetime: null,
        checkout_datetime: null,
        searchText: null
      },
      originalRecordData: [],
      isModalVisible: false,
      objModal: [
        {
          title: "common.delete_modal.title",
          body: "apartmentBooking.reasonCancelBooking.notiCancelBooking",
          buttonNo: "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],
      search: {
        code: "",
        apartment_code: "",
        fromsize: "",
        tosize: "",
        status: "",
        owner_resident: ""
      },
      isLoading: false,
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      },
      booking_id: null,
      controlStatusBooking: {
        isEmpty: false,
        isConfirm: false,
        isOnboard: false,
        isCheckinSoon: false,
        isCheckoutSoon: false,
        isDeposit: false
      },
      tabs_floor: {},
      ApartmentBookingStatus: Enum.ApartmentBookingStatus,
      cancelBookingData: {
        id: null,
        reasonCancel: null
      }
    };
  },
  watch: {
    GET_APARTMENT_BOOKING_LIST_DATA: function() {
      let paginate = this.GET_APARTMENT_BOOKING_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      let data = this.GET_APARTMENT_BOOKING_LIST_DATA.results;
      this.apartmentBookingItems = [];
      data.forEach((value, index) => {
        let nonumber =
          index +
          1 +
          (this.paginateData.currentPage - 1) * this.paginateData.pageSize;
        let checkInDate = utils.formatSqlDate(value.checkin_datetime, null, "HH:mm DD-MM-YYYY");
        let checkOutDate = utils.formatSqlDate(value.checkout_datetime, null, "HH:mm DD-MM-YYYY");
        let item = {
          id: value.id,
          nonumber: nonumber,
          bookingCode: value.booking_code,
          customerName: value.customer.full_name,
          customerPhone: value.customer.phone,
          checkInDate: checkInDate,
          checkOutDate: checkOutDate,
          status: value.status,
          isCancelBooking: value.is_cancel_booking
        };
        this.apartmentBookingItems.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA",
      "GET_APARTMENT_BOOKING_LIST_DATA"
    ])
  },
  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onShowError: function(mess) {
      this.ON_SHOW_TOAST({
        message: mess,
        styleType: "danger"
      });
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.status === 2) return "row-booking-cancel";
    },
    onClickTabs: function(value) {
      switch (value) {
        case 1:
          this.onSearchApartmentBooking();
          break;

        case 2:
          break;

        default:
          break;
      }
    },
    onChangeBookingStatus: function(value) {
      this.bookingStatusSelect = value;
      this.getApartmentBooking(1);
    },
    onAddNewBooking: function() {
      this.$router.push({
        name: "ApartmentBookingDetail",
        params: {
          id: 0
        }
      });
    },
    onOpenBookingDetail: function(data) {
      this.$router.push({
        name: "ApartmentBookingDetail",
        params: {
          id: data.id
        }
      });
    },
    onSearchApartmentBooking: function() {
      this.getApartmentBooking(1);
    },
    getApartmentBooking: function(page) {
      let filter = {
        params: {
          page: page,
          // startDate: utils.formatSqlUtcDate(this.bookingDate.checkin_datetime, "DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss"),
          // endDate: utils.formatSqlUtcDate(this.bookingDate.checkout_datetime, "DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss"),
          startDate: this.getDateSeachBooking().startDateTime,
          endDate: this.getDateSeachBooking().endDateTime,
          status: this.bookingStatusSelect,
          searchText: this.bookingDate.searchText
        }
      };
      this.GET_APARTMENT_BOOKING_LIST(filter);
      this.getNumberBookingInStatusList()
    },
    getDateSeachBooking: function() {
      if (!utils.isEmptyString(this.bookingDate.checkin_datetime) && utils.isEmptyString(this.bookingDate.checkout_datetime)) {
        let startDateTime = utils.formatSqlUtcStartOfDate(this.bookingDate.checkin_datetime, "DD/MM/YYYY", "YYYY-MM-DD HH:mm");
        // let endDateTime = utils.formatSqlUtcEndOfDate(this.bookingDate.checkin_datetime, "DD/MM/YYYY", "YYYY-MM-DD HH:mm");

        return {
          startDateTime: startDateTime,
          endDateTime: null
        };
      } else if (!utils.isEmptyString(this.bookingDate.checkout_datetime) && utils.isEmptyString(this.bookingDate.checkin_datetime)) {
        // let startDateTime = utils.formatSqlUtcStartOfDate(this.bookingDate.checkout_datetime, "DD/MM/YYYY", "YYYY-MM-DD HH:mm");
        let endDateTime = utils.formatSqlUtcEndOfDate(this.bookingDate.checkout_datetime, "DD/MM/YYYY", "YYYY-MM-DD HH:mm");

        return {
          startDateTime: null,
          endDateTime: endDateTime
        };
      } else if (!utils.isEmptyString(this.bookingDate.checkin_datetime) && !utils.isEmptyString(this.bookingDate.checkout_datetime)) {
        let startDateTime = utils.formatSqlUtcStartOfDate(this.bookingDate.checkin_datetime, "DD/MM/YYYY", "YYYY-MM-DD HH:mm");
        let endDateTime = utils.formatSqlUtcEndOfDate(this.bookingDate.checkout_datetime, "DD/MM/YYYY", "YYYY-MM-DD HH:mm");

        return {
          startDateTime: startDateTime,
          endDateTime: endDateTime
        };
      }
      return {
        startDateTime: null,
        endDateTime: null
      };
    },
    closeModal() {
      this.isModalVisible = false;
    },
    makeColorButton: function(isStatus) {
      if (isStatus == "isEmpty") {
        this.controlStatusBooking.isEmpty = !this.controlStatusBooking.isEmpty;
      } else if (isStatus == "isConfirm") {
        this.controlStatusBooking.isConfirm = !this.controlStatusBooking
          .isConfirm;
      } else if (isStatus == "isOnboard") {
        this.controlStatusBooking.isOnboard = !this.controlStatusBooking
          .isOnboard;
      } else if (isStatus == "isCheckinSoon") {
        this.controlStatusBooking.isCheckinSoon = !this.controlStatusBooking
          .isCheckinSoon;
      } else if (isStatus == "isCheckoutSoon") {
        this.controlStatusBooking.isCheckoutSoon = !this.controlStatusBooking
          .isCheckoutSoon;
      } else {
        this.controlStatusBooking.isDeposit = !this.controlStatusBooking
          .isDeposit;
      }
    },
    onCustomPagination: function(data) {
      this.paginateData.currentPage = data;
      this.getApartmentBooking(data);
    },
    // cancel booking
    onShowModalReasonCancelBooking: function(bookingData) {
      this.cancelBookingData = {
        id: bookingData.id,
        reasonCancel: null
      };
      $(this.$refs[`modal-reason-cancel-booking`]).modal("show");
    },
    onCloseReasonCancelBooking: function() {
      $(this.$refs[`modal-reason-cancel-booking`]).modal("hide");
    },
    onShowConfirmCancelBooking: function() {
      if (utils.isEmptyString(this.cancelBookingData.reasonCancel)) {
        this.onShowError(this.$t("apartmentBooking.reasonCancelBooking.title"));
      } else {
        this.isModalVisible = true;
      }
    },
    onConfirm: function() {
      this.isModalVisible = false;
      this.CANCEL_APARTMENT_BOOKING_V2(this.cancelBookingData)
        .then(
          function() {
            this.onCloseReasonCancelBooking();
            this.getApartmentBooking(this.paginateData.currentPage);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    getNumberBookingInStatusList: function() {
      let filter = {
        params: {
          startDate: this.getDateSeachBooking().startDateTime,
          endDate: this.getDateSeachBooking().endDateTime,
          searchText: this.bookingDate.searchText
        }
      };
      this.GET_NUMBER_BOOKING_IN_STATUS_LIST(filter).then(
        function(res) {
          let data = res;
          data.forEach(el => {
            let index = this.bookingStatusList.findIndex(
              x => x.value == el.value
            );
            if (index !== -1) {
              this.bookingStatusList[index].total = el.total;
            }
          });
        }.bind(this)
      );
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_APARTMENT_BOOKING_LIST",
      "CANCEL_APARTMENT_BOOKING_V2",
      "GET_NUMBER_BOOKING_IN_STATUS_LIST"
    ])
  },

  created() {
    this.onSearchApartmentBooking();
  },
  mounted() {
    this.getNumberBookingInStatusList()
    // this.GET_NUMBER_BOOKING_IN_STATUS_LIST().then(
    //   function(res) {
    //     let data = res;
    //     data.forEach(el => {
    //       let index = this.bookingStatusList.findIndex(
    //         x => x.value == el.value
    //       );
    //       if (index !== -1) {
    //         this.bookingStatusList[index].total = el.total;
    //       }
    //     });
    //   }.bind(this)
    // );
  }
};
</script>

<style lang="scss" scoped>
.search {
  box-shadow: none;
  border-color: #d2d6de;
  z-index: 2;
  float: left;
  margin-bottom: 8px;
  margin-right: 5px;
  height: 30px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.table-responsive :deep(.b-table .row-booking-cancel) {
  background-color: #f5c6cb;
  // border: 1px solid blue;
}

.customer-type-class {
  padding: 5px 15px;
  cursor: pointer;
}
.border-right {
  border-right: 1px solid #000000;
}
.customer-type-select {
  font-weight: bold;
  color: #006ad4;
}
</style>



// WEBPACK FOOTER //
// src/views/ApartmentBooking/ApartmentBookingList.vue